/**
 * Small presentational helpers shared by every evidence file list (claims,
 * inspections, and future surfaces). Kept framework-generic - no claim or
 * inspection specifics - so both surfaces render byte-identical rows.
 */
import { FileText, Film, Image as ImageIcon } from 'lucide-react'

/** Human-readable byte size, e.g. "0 B", "12 KB", "3.4 MB". */
export function formatBytes(bytes: number | null | undefined): string {
  if (!bytes) return '0 B'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

/** Filetype glyph for a row's thumbnail slot when there's no image preview. */
export function fileTypeIcon(mime: string | null | undefined) {
  const m = mime ?? ''
  if (m.startsWith('image/')) return <ImageIcon className="h-3.5 w-3.5" />
  if (m.startsWith('video/')) return <Film className="h-3.5 w-3.5" />
  return <FileText className="h-3.5 w-3.5" />
}
